"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpResponseLocationEnum = void 0;
var HttpResponseLocationEnum;
(function (HttpResponseLocationEnum) {
    HttpResponseLocationEnum["HEADER"] = "HEADER";
    HttpResponseLocationEnum["BODY"] = "BODY";
})(HttpResponseLocationEnum = exports.HttpResponseLocationEnum || (exports.HttpResponseLocationEnum = {}));
//# sourceMappingURL=httpResponseLocationEnum.js.map